import { render } from "./_FormBuilder.vue?vue&type=template&id=89221d8c"
import script from "./_FormBuilder.vue?vue&type=script&lang=js"
export * from "./_FormBuilder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/Pieces/FormElements/_FormBuilder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "89221d8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('89221d8c', __exports__)) {
    api.reload('89221d8c', __exports__)
  }
  
  module.hot.accept("./_FormBuilder.vue?vue&type=template&id=89221d8c", () => {
    api.rerender('89221d8c', render)
  })

}


export default __exports__